import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import Register from '@/views/Register.vue'
import Dashboard from '@/views/Dashboard.vue'
import WeatherDetail from '@/views/WeatherDetail.vue'
import Areas from '@/views/Areas.vue'
import Account from '@/views/Account.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/weather-detail/:areaId',
    name: 'WeatherDetail',
    component: WeatherDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/areas',
    name: 'Areas',
    component: Areas,
    meta: { requiresAuth: true }
  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
    meta: { requiresAuth: true }
  },
  {
    path: '/sample/:id',
    name: 'SampleDetail',
    component: WeatherDetail  // 統合: WeatherDetailがサンプルモードも処理
  },
  {
    path: '/test-emagram-cloud',
    name: 'TestEmagramCloud',
    component: () => import('@/views/TestEmagramCloud.vue')
  },
  {
    path: '/admin-dashboard',
    name: 'AdminDashboard',
    component: () => import('@/views/AdminDashboard.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()

  // アクセストークンはあるが user 未読み込みの場合は、プロフィール取得完了を待つ
  // (URLバー直接アクセス時にmain.jsのinitializeAuth完了より先にガードが走る競合対策)
  if (authStore.isAuthenticated && !authStore.user) {
    await authStore.initializeAuth()
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!authStore.isAuthenticated) {
      next({ name: 'Login', query: { redirect: to.fullPath } })
    } else if (to.matched.some(record => record.meta.requiresAdmin)) {
      if (!authStore.user?.is_staff) {
        next({ name: 'Dashboard' })
      } else {
        next()
      }
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router